//add useAppContext.js
import { useContext } from "react";
import { AppContext } from "../../App/context/appContext"

const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error("useAppContext must be used within a AppContextProvider");
  }
  return context;
};
export default useAppContext;
